import getPercentageAmount from './getPercentageAmount';

interface IGetValidRangesParams {
  amount: number;
  precision?: number;
  maxPercentage?: {
    warning?: number | null;
    limit?: number | null;
    fallback?: number;
  };
  minPercentage?: {
    warning?: number | null;
    limit?: number | null;
    fallback?: number;
  };
}

interface IGetValidRanges {
  minLimit: number;
  minWarning: number | null;
  maxWarning: number | null;
  maxLimit: number;
}

const PERCENTAGE_OPTIONS: Required<Pick<IGetValidRangesParams, 'minPercentage' | 'maxPercentage'>> = {
  minPercentage: {
    warning: null,
    limit: null,
    fallback: 0,
  },
  maxPercentage: {
    warning: null,
    limit: null,
    fallback: 0,
  },
} 

function getValidRanges({
  amount: base,
  precision,
  maxPercentage,
  minPercentage,
}: IGetValidRangesParams): IGetValidRanges {
  const OPTIONS = {
    // ...MAX_PERCENTAGE_DEFAULTS,
    minPercentage: {
      ...PERCENTAGE_OPTIONS.minPercentage,
      ...minPercentage,
    },
    maxPercentage: {
      ...PERCENTAGE_OPTIONS.maxPercentage,
      ...maxPercentage,
    },
  };

  // percentage is reprecented as a number 0 - 1; ex: 25.55% => .2555
  const minLimitPercentage = OPTIONS.minPercentage.limit ? -Math.abs(OPTIONS.minPercentage.limit) : null;
  const minWarningPercentage = OPTIONS.minPercentage.warning ? -Math.abs(OPTIONS.minPercentage.warning) : null;
  
  const maxLimitPercentage = OPTIONS.maxPercentage.limit ? Math.abs(OPTIONS.maxPercentage.limit) : null;
  const maxWarningPercentage = OPTIONS.maxPercentage.warning ? Math.abs(OPTIONS.maxPercentage.warning) : null;

  return {
    minWarning: getPercentageAmount({ base, percentage: minWarningPercentage, precision }),
    maxWarning: getPercentageAmount({ base, percentage: maxWarningPercentage, precision }),

    minLimit: getPercentageAmount({ base, percentage: minLimitPercentage, precision, fallback: OPTIONS.minPercentage.fallback  }),
    maxLimit: getPercentageAmount({ base, percentage: maxLimitPercentage, precision, fallback: OPTIONS.maxPercentage.fallback }),
  }
}


export default getValidRanges;
